import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ItemList from 'flarum/common/utils/ItemList';
import PollGroupForm from './PollGroup/PollGroupForm';
import PollGroupFormState from '../states/PollGroupFormState';
import ComposeHero from './ComposeHero';
export default class ComposePollGroupPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "pollGroup", null);
    _defineProperty(this, "loading", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('pollGroupsEnabled') || !app.forum.attribute('canStartPollGroup')) {
      m.route.set('/');
      return;
    }
    this.bodyClass = 'App--compose-poll-group';
    const editId = m.route.param('id');
    const promise = editId ? this.loadEditingPollGroup(editId) : Promise.resolve(PollGroupFormState.createNewPollGroup());
    promise.then(pollGroup => {
      var _this$pollGroup;
      this.pollGroup = pollGroup;
      if (pollGroup != null && pollGroup.exists && !pollGroup.canEdit()) {
        m.route.set('/');
        return;
      }
      const titleKey = "fof-polls.forum.poll_groups.composer.".concat((_this$pollGroup = this.pollGroup) != null && _this$pollGroup.id() ? 'edit' : 'add', "_title");
      app.history.push('compose-poll-group', app.translator.trans(titleKey));
      app.setTitle(app.translator.trans(titleKey));
      m.redraw();
    });
  }
  async loadEditingPollGroup(editId) {
    const cached = app.store.getById('poll_groups', editId);
    if (cached) return cached;
    this.loading = true;
    const pollGroup = await app.store.find('poll_groups', editId);
    this.loading = false;
    return pollGroup;
  }
  view() {
    return m(PageStructure, {
      className: "ComposePollGroupPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: this.loading || !this.pollGroup
    }, this.contentItems().toArray());
  }
  hero() {
    if (!this.pollGroup) return null;
    return m(ComposeHero, {
      item: this.pollGroup,
      className: "ComposePollGroupHero",
      translationPrefix: "fof-polls.forum.poll_groups.composer",
      managerRoute: "fof.polls.groups.list",
      managerIcon: "fas fa-layer-group",
      managerLabel: app.translator.trans('fof-polls.forum.poll_groups.composer.groups_manager'),
      viewRoute: "fof.polls.groups.view",
      viewIcon: "far fa-arrow-up-right-from-square",
      viewLabel: app.translator.trans('fof-polls.forum.poll_groups.composer.view_group')
    });
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    if (this.pollGroup) {
      items.add('form', m(PollGroupForm, {
        pollGroup: this.pollGroup,
        onsubmit: this.onsubmit.bind(this)
      }));
    }
    return items;
  }
  async onsubmit(data, state) {
    const isNew = state.pollGroup.id() === undefined;
    await state.save(data);
    const alertId = app.alerts.show({
      type: 'success'
    }, app.translator.trans('fof-polls.forum.poll_groups.composer.success'));
    setTimeout(() => app.alerts.dismiss(alertId), 10000);
    if (isNew) {
      m.route.set(app.route('fof.polls.groups.list'));
    }
  }
}
flarum.reg.add('fof-polls', 'forum/components/ComposePollGroupPage', ComposePollGroupPage);